module.exports = __webpack_public_path__ + "static/media/img_stp_card_unknown.0c4a3227.png";